export const DOWNLOAD_REQUEST = 'DOWNLOAD_REQUEST';